export function SVG_AddArc(ex, ey, r) {
  return "A" + r + "," + r + " 0 0,1 " + ex + "," + ey + " ";
}
